import { useI18n } from 'vue-i18n'

export function getErrorCode(code: any): any {
  return typeof code === 'string' ? code.match(/\/([^/]+)$/)?.[1] || code : code
}

export function getRecordsList(records: any): string {
  if (!records || !Array.isArray(records)) {
    return '<ul></ul>'
  }

  const listItems = records.map((item: any) => `<li> • ${item}</li>`).join('\n')
  return `<ul>\n${listItems}\n</ul>`
}

export function validateTranslate(
  code: string,
  params?: string[],
  label?: string
): any {
  if (!code) return
  const { t } = useI18n()
  let translated: string
  if (params) {
    translated = t(code, params)
  } else {
    translated = t(code)
  }
  if (translated === code) {
    return label || code
  }
  return translated
}
